<template>
  <div>
    <div v-if="!readOnly" class="cr">
      <label>{{ $t('corrente-de-informacao-da-ocupacao') }} </label>
      <b-form-select
        v-model="outCurrent"
        @change="ChangeOccupancyCurrent()"
        :options="outCurrents"
      ></b-form-select>
    </div>
    <div class="cr" v-if="outCurrent && !readOnly">
      <label>{{ $t('corrente-de-informacao-da-capacidade-de-producao') }} </label>
      <b-form-select
        v-model="current"
        :options="currents"
        @change="ChangeCapacityCurrent()"
      ></b-form-select>
    </div>
    <b-form v-if="current" class="b-layout" @submit.prevent="">
      <b-card >
        <label v-if="equipments.length > 0" class="ml-4 mb-2">{{ $t('adicionar-novo-equipamento') }}</label>
        <label v-if="equipments.length == 0 && readOnly" class="ml-2">{{ $t('nao-ha-equipamentos') }}</label>
        <div v-if="!readOnly">
          <div class="inp">
            <label>{{$t('name')}} </label>
            <b-input
              class="input-equip"
              v-model="equipName"
              :placeholder="`Secador ${this.equipments.length + 1}`"
              type="text"
              maxlength="18"
            ></b-input>
          </div>
          <div class="inputIcon">
            <label class="capacidade">{{ $t('capacidade-sc-dia') }} </label>
            <b-input
              class="input-equip"
              @change="verifiedValue()"
              v-model="capacity"
              min="0"
              step="1"
              type="number"
            ></b-input>
            <b-icon
              class="btn-icon"
              icon="plus-circle-fill"
              :title="$t('adicionar')"
              @click="addAttr()"
              aria-hidden="true"
            />
          </div>
          <hr v-if="this.equipments.length > 0" />
        </div>

        <div v-for="(equip, index) in equipments" :key="equip.Name + index">
          <div  class="switch-items">
            <b-form-checkbox
              class="switch-item"
              v-model="equip.Status"
              @change="ChangeOnOff($event, equip)"
              :disabled="false"
              switch
            >
              <div>
                {{
                  equip.Name + ` (${commaFormat(ParseNumber(equip.Capacity))})`
                }}
              </div>
            </b-form-checkbox>
            <b-icon
              v-if="!readOnly"
              class="btn-icon2"
              icon="dash-circle-fill"
              :title="$t('remover')"
              @click="confirmDelete(index)"
            />
          </div>
        </div>
      </b-card>
      <div class="total">
        <div class="inp">
          <label class="label2">{{ $t('capacidade-de-producao-sc-dia') }}</label>
          <p>{{ commaFormat(ParseNumber(CapacidadeInstalada.value)) }}</p>
        </div>
        <div class="inp">
          <label>{{ $t('ocupacao-1') }}</label>
          <p>{{ ParseNumber(ocupacaoCalc.value) }}</p>
        </div>
      </div>
    </b-form>
    <b-modal
      id="confirmRemoveEquip"
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      title="$t('atention')"
      @ok="removeAttr(index)"
      @cancel="$bvModal.hide('confirmRemoveEquip')"
      >{{ $t('deseja-remover-o-equipamento') }} "{{ tempValueConfirmRemove }}" {{$t('da-lista')}}</b-modal
    >
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { showError } from "@/global";
import { NumberFormat, FormatComma } from "../../../flowchart/utils/tools";
import { FiltersMixin } from "../../../mixins/filtersMixin";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },
  mixins: [FiltersMixin],

  data() {
    return {
      attrList: ["CapacidadeInstalada"],
      CapacidadeInstalada: {},
      ocupacaoCalc: 0,
      capacity: 0,
      current: null,
      currents: [{ value: null, text:this.$t('selecione-uma-corrente-de-entrada') }],
      outCurrent: null,
      outCurrents: [{ value: null, text:this.$t('selecione-uma-corrente-de-saida') }],
      equipments: [],
      equipCap: [],
      equipName: null,
      formatNumber: NumberFormat,
      commaFormat: FormatComma,
      index: 0,
      tempValueConfirmRemove: 0,
    };
  },

  watch: {
    outCurrent(value) {
      if (value) {
        this.node.CurrentOcupacaoCalc = value;
      }
    },

    current(value) {
      if (value) {
        this.node.CurrentCapaProd = value;
      }
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        if (this.node.CurrentOcupacaoCalc) {
          this.outCurrent = this.node.CurrentOcupacaoCalc;
          this.ChangeOccupancyCurrent();
        }

        if (this.node.CurrentCapaProd) {
          this.current = this.node.CurrentCapaProd;
          this.ChangeCapacityCurrent();
        }

        if (this.node.dryers) {
          this.node.dryers.forEach((e) => {
            this.equipments.push(e);
          });
        }
      }
      this.updateNode();
    },

    confirmDelete(i) {
      this.index = i;
      this.$bvModal.show("confirmRemoveEquip");
      this.tempValueConfirmRemove = this.equipments[i].Name;
    },

    verifiedValue() {
      if (this.capacity < 0) {
        this.capacity = 0;
        return;
      }

      this.capacity = this.ParseInteger(this.capacity);
    },

    addAttr() {
      let equip = {
        Name: `${
          this.equipName
            ? this.equipName
            : `Secador ${this.equipments.length + 1}`
        }`,
        Capacity: this.capacity,
        Status: true,
      };
      this.capacity = 0;
      this.equipName = "";

      if (
        !this.equipments.find((a) => a.Name == equip.Name) &&
        equip.Capacity != 0
      ) {
        this.equipments.push(equip);
      } else if (equip.Capacity == 0) {
        showError(
          this.$t('a-capacidade-do-equipamento-nao-poder-ser-menor-ou-igual-a-0')
        );
      } else
        showError(this.$t('um-equipamento-com-o-mesmo-nome-ja-foi-adicionado-a-lista'));

      this.ChangeCapacity();
      this.updateNode();
    },

    removeAttr(i) {
      let remove = this.equipments[i];
      this.equipments = this.equipments.filter((l) => l.Name != remove.Name);
      this.ChangeCapacity();
      this.updateNode();
    },

    loadCurrents() {
      let crList = SingletonEnginnering.currents;
      this.outCurrents.splice(1);
      crList.forEach((cr) => this.outCurrents.push({ value: cr, text: cr }));
    },

    loadOutCurrents() {
      let crList = SingletonEnginnering.currents;
      this.currents.splice(1);
      crList.forEach((cr) => this.currents.push({ value: cr, text: cr }));
    },

    updateNode() {
      let attrs = [this.CapacidadeInstalada.clone(), this.ocupacaoCalc.clone()];
      this.node.dryers = [];
      this.equipments.forEach((e) => {
        let equip = {};
        equip.Name = e.Name;
        equip.Capacity = e.Capacity;
        equip.Status = e.Status;
        equip.Status ? 1 : 0;
        this.node.dryers.push(equip);
      });
      this.node.attrs = attrs;
    },

    ChangeCapacity() {
      if (this.CapacidadeInstalada) this.CapacidadeInstalada.value = 0;
      this.equipments.forEach((e) => {
        if (e.Status)
          this.CapacidadeInstalada.value += parseFloat(
            String(e.Capacity).replace(",", ".")
          );
      });
    },

    ChangeOccupancyCurrent() {
      let attrs = SingletonEnginnering.getCurrentProperties(this.outCurrent);

      let props = SingletonEnginnering.getCurrentPropertiesAttributes(
        this.outCurrent,
        attrs[0]
      );
      props.forEach((p) => {
        if (p.key == "W") this.ocupacaoCalc = p;
      });
    },

    ChangeCapacityCurrent() {
      let attrs = SingletonEnginnering.getCurrentProperties(this.current);

      let props = SingletonEnginnering.getCurrentPropertiesAttributes(
        this.current,
        attrs[0]
      );
      props.forEach((p) => {
        if (p.key == "W") this.CapacidadeInstalada = p;
      });
    },

    ChangeOnOff(event, prop) {
      prop.Status = event;
      this.ChangeCapacity();
      this.updateNode();
    },
  },

  mounted() {
    this.loadCurrents();
    this.loadOutCurrents();
    this.loadNode();
    this.ChangeCapacity();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
  width: 720px;
}

.b-layout {
  display: flex;
  justify-content: space-between;
  width: 800px;
}

.input-equip {
  text-align: center;
  width: 162px;
  margin-left: 15px;
}

.label2 {
  margin-right: 10px;
  margin-top: 2px;
}

.attr-list {
  width: 460px;
}

.card {
  margin: 10px;
}

.inputIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -10px;
}

input {
  margin: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inp2 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.inp {
  margin-right: 41px;
  margin-left: -08px;
}

p {
  margin-bottom: 5px;
}

.inp-number {
  width: 150px;
}

.cr {
  margin: 2%;
}

.btn-icon {
  color: rgb(255, 113, 10);
  font-size: 1.5em;
  cursor: pointer;
  margin-left: 5%;
}

.btn-icon2 {
  color: rgba(255, 113, 10);
  font-size: 1.3em;
  cursor: pointer;
}

.capacidade {
  margin-right: 5px;
}

.total {
  margin-top: 25px;
  margin-left: 20px;
}

.switch-items {
  width: 340px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: -09px;
  margin-bottom: 8px;
}
</style>
